import axios from "axios"
import { GeolocationAutocompleteType, GeolocationPlaceType } from "@jobintrans/base-ui.types.api-integrations"

export const GeoService = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
})
GeoService.interceptors.response.use(
  async response => {
    return response.data
  },
  async error => {
    // eslint-disable-next-line no-undef
    return Promise.reject(error)
  },
)

const autocomplete = (q: string, lang = "pl") =>
  GeoService.get<null, GeolocationAutocompleteType[]>(
    `https://autocomplete-ki6gvzx6ua-uc.a.run.app?q=${q}&lang=${lang}`,
  )

const place = (id: string, lang = "pl") =>
    GeoService.get<null, GeolocationPlaceType>(
        `https://place-ki6gvzx6ua-uc.a.run.app?id=${id}&lang=${lang}`,
    )

export const GeolocationService = {
  autocomplete,
  place,
}
